module.exports = __webpack_public_path__ + "static/media/005-ethiopia.dd595cde.svg";